
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class BooleanIcon extends React.Component {

    _getTrueIcon() {

        return <span styleName="tick-icon">&#10003;</span>;
    }

    _getFalseIcon() {

        return <span styleName="cross-icon">&#10007;</span>;
    }

    _getStyleName() {

        if (this.props.showHoverEffect) {

            return 'container--clickable';

        } else {

            return 'container';
        }
    }

    render() {

        return (
            <div styleName={ this._getStyleName() } { ...this.props }>
                { this.props.value ? this._getTrueIcon() : this._getFalseIcon() }
            </div>
        );
    }
}

export default CSSModules(BooleanIcon, style);


// WEBPACK FOOTER //
// ./components/BooleanIcon/index.js